import React, { Suspense, useContext } from "react";
import {
  HashRouter as Router,
  Routes,
  Route,
  Navigate,
  Outlet,
} from "react-router-dom";
import LoginPage from "./pages/login/LoginPage";
import { useAuth } from "./hooks/useAuth";
import DashboardLayout from "./layouts/DashboardLayout";
// import AddBlog from "./pages/blogs/AddEditBlog";
// import BlogList from "./pages/blogs/BlogList";
// import BlogCategoryList from "./pages/blogcategory/BlogCategoryList";
// import AddEditBlogCategory from "./pages/blogcategory/AddEditBlogCategory";
// import BlogTopicList from "./pages/blogtopic/BlogTopicList";
// import AddEditBlogTopic from "./pages/blogtopic/AddEditBlogTopic";
import { AuthContext } from "./contexts/AuthContext";
import Loader from "./components/Loader";
import Dashboard from "./pages/dashboard/Dashboard";
import AdminList from "./pages/AdminList";
import SubscribersList from "./pages/SubscribersList";
import CompanyList from "./pages/CompanyList";
import AuthLayout from "./layouts/AuthLayout";
import Verification from "./pages/login/Verification";
import UserPromptsList from "./pages/UserPromptsList";

const RequireAuth = ({ children }) => {
  const { token } = useAuth(AuthContext);
  if (!token) {
    return <Navigate to={"/login"} />;
  }
  return (
    <>
      <DashboardLayout>
        <Suspense fallback={<Loader />}>
          <Outlet />
        </Suspense>
      </DashboardLayout>
    </>
  );
};
const RoutesComponent = () => {
  return (
    <Router>
      <Routes>
        <Route element={<AuthLayout />}>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/verification" element={<Verification />} />
        </Route>
        <Route path="/" element={<RequireAuth />}>
          <Route
            index
            path="/"
            element={<Navigate to="/dashboard" replace />}
          />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="admins" element={<AdminList />} />
          <Route path="user-prompts" element={<UserPromptsList />} />
          <Route path="subscribers" element={<SubscribersList />} />
          <Route path="companies" element={<CompanyList />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default RoutesComponent;
